import React, {PureComponent } from 'react'
import {Form, Input, Modal, Select, message, Radio, DatePicker} from 'antd'
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');
const {Option} = Select;
const formItemLayout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 14,
    },
}
class OrderCancelledModal extends PureComponent {
    state = {
        order: {},
    }

    handleOk = () => {
        const {onOk} = this.props
        const {validateFields, getFieldsValue, resetFields} = this.props.form
        validateFields((errors, values) => {
            if (errors) {
                return
            }
            const data = {
                ...getFieldsValue(),
            }
            data.optDt = data.optDt.format("YYYY-MM-DD HH:mm:ss");
            data.optType = "cancelled";
            data.orderId = this.state.order.id;
            resetFields()
            onOk(data)
        })
    }

    hideModal = () => {
        const {onCancel} = this.props
        const {resetFields} = this.props.form
        onCancel()
        resetFields()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.visible && !this.props.visible) {
            this.setState({
                order: nextProps.order
            })
        }
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        const {visible} = this.props;
        return (
            <Modal onOk={this.handleOk}
                   title={this.state.order.orderNo + " " + this.state.order.entName}
                   visible={visible}
                   onCancel={this.hideModal}
                   okText="确定"
                   cancelText="取消"
            >
                <Form {...formItemLayout}>
                    <Form.Item label="取消时间:">
                        {getFieldDecorator('optDt', {
                            initialValue: moment(),
                            rules: [{required: true, message: '该项必填'}]})
                        (<DatePicker showTime format="YYYY-MM-DD HH:mm:ss" style={{width: '100%'}}/>)}
                    </Form.Item>

                    <Form.Item label="取消原因:">
                        {getFieldDecorator('reason', {
                            rules: [{required: true, message: '该项必填'}]
                        })(<Input />)}
                    </Form.Item>
                </Form>
            </Modal>
        )
    }
}
const WrapOrderCancelledModal = Form.create()(OrderCancelledModal)
export default WrapOrderCancelledModal
